@let isLoading = rolesLoadingState() === LoadingState.LOADING;
@let isLoaded = rolesLoadingState() === LoadingState.READY;
@let absoluteRolesCount = totalCountWithoutFilter();
@let roles = (roles$ | async) ?? [];

@if (isLoaded && absoluteRolesCount === 0) {
  <div class="entity-addition">
    <div class="entity-addition__inner">
      <lib-svg-icon
        icon="user-line"
        size="44"
      />
      <div>{{ 'monitoring.roles.no-roles-available' | translate }}</div>
      @if (canManageRoles()) {
        <lib-button
          buttonStyle="primary"
          buttonSize="large"
          (click)="openRoleModal('monitoring.roles.modal.role-creation', RolesAction.Create)"
        >
          <span>{{ 'monitoring.roles.add-role' | translate }}</span>
        </lib-button>
      }
    </div>
  </div>
} @else {
  <section class="page-content page-viewport">
    <mon-page-toolbar
      titleTranslateKey="monitoring.menu.roles"
      [searchControl]="searchControl"
      searchPlaceholderTranslateKey="monitoring.roles.dashboard.search"
      [showFiltersButton]="false"
      [actions]="toolbarActions"
      (actionClick)="onToolbarAction($event)"
    />

    <section class="page-content page-table page-table-scroll">
      <!-- Таблица ролей -->
      <div class="page-table-scroll__content">
        <lib-table
          class="page-table-scroll__table roles-table"
          [columns]="columns"
          trCustomClass="desktop-table-row--hoverable"
          [dataSource]="roles"
          [cellTemplates]="{
            name: nameTpl,
          }"
          [loaded]="isLoaded"
          [loading]="isLoading"
          (desktopRowClick)="
            openRoleModal('monitoring.roles.modal.role-editing', RolesAction.Edit, $event.id)
          "
        ></lib-table>
      </div>

      @if (!(roles.length === 0 && pagination().pageIndex === 1)) {
        <lib-pagination
          (paginationChange)="onPageChange($event)"
          [loading]="isLoading"
          [totalCount]="totalCount()"
          [pageIndex]="pagination().pageIndex"
          [pageSize]="pagination().pageSize"
        />
      }
    </section>
  </section>
}

<!-- шаблоны ячеек -->
<ng-template
  #nameTpl
  let-role="data"
>
  <div class="roles__cell">
    {{ role.name }}
  </div>
</ng-template>
